import React from 'react'
import ContactPage from '../parts/pages/ContactPage'

export default function Contact() {
  return <ContactPage />
}
